import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Icon from "@/components/icons/Icon/Icon.vue";
import { IconType } from "@/types/icons";
import { SwitchType } from "@/types/cards";
import { computed } from "vue";

interface Props {
  activeSwitchType: SwitchType;
  switchType: SwitchType;
}
interface Emits {
  (e: "toggle-switch-type", switchType: SwitchType): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EmojisAndGiphsSwitch',
  props: {
    activeSwitchType: {},
    switchType: {}
  },
  emits: ["toggle-switch-type"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const isActive = computed(() => props.activeSwitchType === props.switchType);

const appliedIcon = computed(() => {
  if (props.switchType === SwitchType.Gif && isActive.value) {
    return IconType.GIF_BLACK;
  }
  if (props.switchType === SwitchType.Gif) {
    return IconType.GIF_GRAY;
  }

  if (isActive.value) {
    return IconType.EMOJI_BLACK;
  }

  return IconType.EMOJI_GRAY;
});

const toggleSwitchType = () => {
  emit("toggle-switch-type", props.switchType);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["emojis-option", { isActive: isActive.value }]),
    onClick: toggleSwitchType
  }, [
    _createVNode(Icon, {
      icon: appliedIcon.value,
      alt: "emoji-icon",
      class: "switch-icon"
    }, null, 8, ["icon"])
  ], 2))
}
}

})